
export default {
  name: 'ProductPageItemsCarousel',
  props: {
    title: {
      type: String,
      default: null,
    },

    productList: {
      type: Array,
      required: true,
    },

    carouselBem: {
      type: Array,
      default: () => [],
    },

    slidesPerView: {
      type: Object,
      default: () => ({
        xxs: 1.25,
        xs: 2,
        sm: 2,
        md: 4,
        lg: 4,
        xl: 4,
      }),
    },

    productImgSide: {
      type: Boolean,
      default: false,
    },
  },
}
